module.exports = __webpack_public_path__ + "img/ruble.890f3da3.svg";